import React, { useState, Suspense, lazy } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Hero from './Hero';
import Main from './Main';
import Bitcoin from './pages/Bitcoin';
import Ethereum from './pages/Ethereum';
import CRANNI from './pages/CRANNI';
import Matic from './pages/Matic';
import MyTickets from './pages/MyTickets';
import Prediction from './pages/Prediction';
import {
  luckBlocksAddress,
  ethLuckBlocksAddress,
  maticLuckBlocksAddress,
  CRANNILuckBlocksAddress,
} from './.config';
import { http } from 'viem';
import { bscTestnet } from '@reown/appkit/networks';

import { createAppKit, AppKit } from '@reown/appkit';
import HeroNFT from './HeroNFT';
import NFTnodes from './pages/NFTnodes';
import HeroToken from './HeroToken';
import Token from './pages/Token';
import Terms from "./pages/Terms";
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useAppKitAccount } from "@reown/appkit/react";
import { HelmetProvider } from 'react-helmet-async';
import { PredictionsProvider } from './pages/Prediction/context/PredictionsContext';

// const Main = lazy(() => import("./Main"));
const Partners = lazy(() => import('./Partners'));
const Footer = lazy(() => import('./components/Footer'));
const Social = lazy(() => import('./Social'));
const ChooseNumber = lazy(() => import('./components/UI/Modals/ChooseNumber'));
const Success = lazy(() => import('./components/UI/Modals/Success'));
// const NFTnodes = lazy(() => import("./pages/NFTnodes"));

// Configuração do ReOwn AppKit
const projectId = 'd5cbf7e239d6f43a9228147366120ae5';
const supportedChains = [bscTestnet];
const queryClient = new QueryClient()


const wagmiAdapter = new WagmiAdapter({
  networks: supportedChains,
  projectId
})


/*
tokenContracts={{
  97: '0x2a3E6a9824c1f59AEFDe1f5eC4F2b4c3460C6992',
  137: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
}}
tokenImages={{
  USDT: 'https://i.imgur.com/2CBfKCE.png',
  DUSD: 'https://i.imgur.com/2CBfKCE.png',
}} */


const appKit = new createAppKit({
  adapters: [wagmiAdapter],
  networks: supportedChains,
  metadata: {
    name: 'LuckBlocks',
    description: 'LuckBlocks Decentralized Casino Platform',
    url: 'https://luckblocks.com',
    icons: ['https://i.imgur.com/9P6NJG4.png']
  },
  projectId,
  features: {
    analytics: true,
  }
});


// const { connector } = appKit;

/*
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: appKit.getWagmiConnectors(), 
  publicClient: ({ chainId }) => ({
    chain: bscTestnet,
    transport: http('https://data-seed-prebsc-1-s1.binance.org:8545')
  }),
}); */

function App() {
  const [showNumber, setShowNumber] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  function getCurrentLAddress() {
    // Logic to determine the laddress based on the current page
    const { hash } = window.location;
    switch (hash) {
      case '#/ethereum':
        return ethLuckBlocksAddress;
      case '#/matic':
        return maticLuckBlocksAddress;
      case '#/CRANNI':
        return CRANNILuckBlocksAddress;
      default:
        return luckBlocksAddress;
    }
  }

  /*
  appKit.setTheme({
    '--rk-colors-accentColor': '#9029d9',
    '--rk-colors-background': '#000000',
    '--rk-modal-border-radius': '24px',
  }); */


  return (
    <>
      <HelmetProvider>
        <WagmiProvider config={wagmiAdapter.wagmiConfig}>
          <QueryClientProvider client={queryClient}>
            <PredictionsProvider>
              <AppContent
                showNumber={showNumber}
                setShowNumber={setShowNumber}
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
                getCurrentLAddress={getCurrentLAddress}
                appKit={appKit}
              />
            </PredictionsProvider>
          </QueryClientProvider>
        </WagmiProvider>
      </HelmetProvider>
    </>
  );
}

// Componente separado para usar hooks dentro do contexto do provider
function AppContent({
  showNumber,
  setShowNumber,
  showSuccess,
  setShowSuccess,
  getCurrentLAddress,
  appKit
}) {

  const { address, isConnected, caipAddress, status, embeddedWalletInfo } = useAppKitAccount()

  return (
    <Router>
      <Header appKit={appKit} />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
              <Main />
              <Bitcoin
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
            </>
          }
        />
        <Route
          path="/ethereum"
          element={
            <>
              <Hero
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
              <Main />
              <Ethereum
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
            </>
          }
        />
        <Route
          path="/CRANNI"
          element={
            <>
              <Hero
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
              <Main />
              <CRANNI
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
            </>
          }
        />
        <Route
          path="/matic"
          element={
            <>
              <Hero
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
              <Main />
              <Matic
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
            </>
          }
        />
        <Route
          path="/my-tickets"
          element={
            <>
              <Hero
                setShowDraw={() => {
                  setShowNumber(true);
                }}
              />
              <Main />
              <MyTickets />
            </>
          }
        />

        <Route
          path="/token"
          element={
            <>
              <HeroToken />
              <Token />
            </>
          }
        />

        <Route
          path="/nftnodes"
          element={
            <>
              <HeroNFT />
              <NFTnodes />
            </>
          }
        />
        <Route path="/terms" element={<Terms />} />
        <Route path="/prediction" element={<Prediction />} />
      </Routes>

      {showNumber && (
        <Suspense>
          <ChooseNumber
            showNumber={showNumber}
            setShowNumber={setShowNumber}
            setShowSuccess={setShowSuccess}
            isConnected={isConnected}
            uaddress={address}
            laddress={getCurrentLAddress()} // Get the appropriate laddress based on the page
          />
        </Suspense>
      )}
      {showSuccess && (
        <Suspense>
          <Success showSuccess={showSuccess} setShowSuccess={setShowSuccess} />
        </Suspense>
      )}
      <Suspense>
        <Partners />
        <Footer />
        <Social />
      </Suspense>
    </Router>
  );
}

export default App;